{
  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "save": "Save",
    "update": "Update",
    "retry": "Retry",
    "error": "Error",
    "ok": "OK",
    "loading": "Loading...",
    "delete": "Delete",
    "show": "Show",
    "hide": "Hide",
    "view": "View",
    "email": "Email",
    "logout": "Logout",
    "subscribe": "Subscribe",
    "upgrade": "Upgrade",
    "manage": "Manage",
    "continue": "Continue",
    "processing": "Processing...",
    "dismiss": "Dismiss",
    "close": "Close",
    "completed": "Completed",
    "remove": "Remove"
  },
  "auth": {
    "login": {
      "appName": "Fluencia",
      "subtitle": "Master your English pronunciation",
      "emailLabel": "Email",
      "emailAccessibility": "Email address",
      "passwordLabel": "Password",
      "passwordAccessibility": "Password",
      "forgotPasswordButton": "Forgot password?",
      "signInButton": "Sign In",
      "dontHaveAccount": "Don't have an account?",
      "signUpLink": "Sign Up",
      "signUpAccessibility": "Sign up",
      "validationError": "Please enter both email and password",
      "loginFailedTitle": "Login Failed"
    },
    "signup": {
      "title": "Create Account",
      "subtitle": "Join Fluencia and start learning",
      "fullNameLabel": "Full Name",
      "fullNamePlaceholder": "John Doe",
      "fullNameError": "Name must be at least 2 characters",
      "emailLabel": "Email",
      "emailError": "Please enter a valid email address",
      "passwordLabel": "Password",
      "passwordError": "Password must be at least 8 characters",
      "confirmPasswordLabel": "Confirm Password",
      "confirmPasswordError": "Passwords do not match",
      "termsCheckboxUnchecked": "Uncheck terms agreement",
      "termsCheckboxChecked": "Accept terms and privacy policy",
      "termsAgreement": "I agree to the",
      "termsOfService": "Terms of Service",
      "privacyPolicy": "Privacy Policy",
      "createAccountButton": "Create Account",
      "alreadyHaveAccount": "Already have an account?",
      "loginLink": "Login",
      "loginAccessibility": "Log in",
      "termsRequiredTitle": "Terms Required",
      "termsRequiredMessage": "Please accept the terms and conditions",
      "registrationFailedTitle": "Registration Failed",
      "confirmTitle": "Confirm Your Email",
      "confirmSentTo": "We've sent a confirmation code to:",
      "codeLabel": "Confirmation Code",
      "codeAccessibility": "Confirmation code",
      "codeError": "Enter the 6-digit code from the email",
      "verifyCodeButton": "Verify Code",
      "resendButton": "Resend code",
      "resendCountdown": "Resend code in {{seconds}}s",
      "resendAccessibility": "Resend code",
      "confirmExpiry": "You can also tap the link in the email instead of typing the code.",
      "confirmTip": "Tip: Check your spam folder if you don't see the email",
      "backToLogin": "Back to Login",
      "fullNameAccessibility": "Full name",
      "emailAccessibility": "Email address",
      "passwordAccessibility": "Password",
      "confirmPasswordAccessibility": "Confirm password"
    },
    "forgotPassword": {
      "title": "Reset Password",
      "subtitle": "Enter your email and we'll send you a link to reset your password",
      "emailLabel": "Email Address",
      "emailError": "Please enter a valid email address",
      "sendResetLink": "Send Reset Link",
      "rememberPassword": "Remember your password?",
      "loginLink": "Login",
      "loginAccessibility": "Log in",
      "successTitle": "Check Your Email",
      "successSentTo": "We've sent a reset code to:",
      "successExpiry": "You can also tap the link in the email instead of typing the code.",
      "successTip": "Tip: Check your spam folder if you don't see the email",
      "successBackButton": "Back to Login",
      "successRetryText": "Didn't receive the email?",
      "successRetryLink": "Try again",
      "successRetryAccessibility": "Try again",
      "emailAccessibility": "Email address",
      "codeLabel": "Reset Code",
      "codeAccessibility": "Reset code",
      "codeError": "Enter the 6-digit code from the email",
      "verifyCodeButton": "Verify Code",
      "resendButton": "Resend code",
      "resendCountdown": "Resend code in {{seconds}}s",
      "resendAccessibility": "Resend code"
    },
    "resetPassword": {
      "title": "Set New Password",
      "subtitle": "Your new password must be at least 8 characters long",
      "newPasswordLabel": "New Password",
      "newPasswordError": "Password must be at least 8 characters",
      "confirmPasswordLabel": "Confirm New Password",
      "confirmPasswordError": "Passwords do not match",
      "updateButton": "Update Password",
      "backToLogin": "Back to Login",
      "backToLoginAccessibility": "Back to login",
      "successTitle": "Password Updated",
      "successMessage": "Your password has been successfully updated. You can now login with your new password.",
      "passwordAccessibility": "New password",
      "confirmPasswordAccessibility": "Confirm new password"
    }
  },
  "chat": {
    "header": {
      "title": "Fluencia Chat",
      "subtitle": "AI Tutor ready",
      "streakDay_one": "{{count}} day",
      "streakDay_other": "{{count}} days"
    },
    "topics": {
      "readyTitle": "Ready to practice?",
      "readyBody": "Send a text or voice message and get instant feedback on your grammar, pronunciation, and fluency.",
      "tipTitle": "Tip",
      "tipBody": "Try the microphone for pronunciation feedback. Speak naturally — mistakes are how you learn!",
      "dayLabel": "Talk about your day",
      "dayPrompt": "\"Today I...\"",
      "weekendLabel": "Describe your weekend",
      "weekendPrompt": "\"Last weekend...\"",
      "hobbyLabel": "Your favorite hobby",
      "hobbyPrompt": "\"I really enjoy...\"",
      "freeLabel": "Free conversation",
      "freePrompt": "Say anything!"
    },
    "input": {
      "placeholder": "Type a message...",
      "voiceButtonLabel": "Record voice message",
      "sendButtonLabel": "Send message",
      "inputLabel": "Message input"
    },
    "voice": {
      "preparingMicrophone": "Preparing microphone...",
      "microphonePermission": "Please allow microphone access if prompted",
      "recording": "Recording",
      "processing": "Processing",
      "listeningPlaceholder": "Listening... speak naturally",
      "silenceWarning": "Keep speaking or recording ends...",
      "recordingWillStop": "Recording will stop at 30 seconds",
      "cancelButton": "Cancel recording",
      "stopButton": "Stop recording",
      "retryButton": "Retry recording",
      "analyzeHint": "Tap the green button to stop and analyze",
      "analyzingHint": "Analyzing your speech...",
      "recordingFailedError": "Recording failed",
      "noSpeechDetectedError": "No speech detected. Please try again.",
      "connectionError": "Check your connection and try again",
      "serviceError": "Service unavailable. Try again later",
      "connectionLostWarning": "Connection lost. Your message will be sent when reconnected."
    },
    "pronunciation": {
      "hint": "Say this aloud",
      "referenceLabel": "Practice saying: {{text}}",
      "freeLabel": "Speak freely for pronunciation practice",
      "dismiss": "Dismiss pronunciation prompt"
    },
    "tts": {
      "connectionError": "Check your connection",
      "serviceError": "Try again later",
      "rateLimited": "Try again later",
      "playbackError": "Playback failed"
    },
    "consent": {
      "title": "AI-Powered Features",
      "subtitle": "Fluencia uses AI to help you learn English",
      "explanation": "To provide personalized feedback on your pronunciation and grammar, we share some of your data with the following third-party AI services:",
      "purposeLabel": "Purpose: ",
      "dataSharedLabel": "Data shared: ",
      "providers": {
        "geminiName": "Google Gemini",
        "geminiPurpose": "Conversation analysis and grammar feedback",
        "geminiDataShared": "Text of your messages (not audio recordings)",
        "openaiName": "OpenAI",
        "openaiPurpose": "Conversation analysis and grammar feedback",
        "openaiDataShared": "Text of your messages (not audio recordings)",
        "anthropicName": "Anthropic",
        "anthropicPurpose": "Role-play scenario generation",
        "anthropicDataShared": "Text of your messages (not audio recordings)",
        "azureName": "Microsoft Azure Speech Services",
        "azurePurpose": "Voice recognition and pronunciation assessment",
        "azureDataShared": "Audio recordings during voice practice"
      },
      "importantInfoTitle": "Important Information",
      "voiceRecordingNote": "Your voice recordings are processed in real-time and not permanently stored",
      "textAnalysisNote": "Text analysis helps identify grammar improvements",
      "withdrawConsentNote": "You can withdraw consent anytime in Settings",
      "privacyPolicyLink": "Read our full Privacy Policy",
      "acceptButton": "I Understand and Agree",
      "declineButton": "Not Now",
      "disclaimerText": "Without consent, AI-powered features like conversation analysis and pronunciation feedback will be unavailable."
    },
    "messages": {
      "sendingStatus": "Sending...",
      "retryTooltip": "Retry sending message",
      "retryText": "Tap to retry",
      "analyzing": "Analyzing...",
      "analysisInProgress": "Analysis in progress",
      "analysisFailed": "Analysis failed",
      "analysisUnavailable": "⚠️ Analysis unavailable",
      "tapToRetryAnalysis": "— Tap to retry",
      "retryAnalysis": "Retry analysis",
      "retryAnalysisHint": "Double-tap to retry the analysis",
      "listenToMessage": "Listen to message",
      "stopListening": "Stop listening",
      "narration": "Narration",
      "cue": "Your line"
    },
    "analysis": {
      "pronunciationSection": "PRONUNCIATION",
      "accuracyLabel": "Accuracy",
      "fluencyLabel": "Fluency",
      "prosodyLabel": "Prosody",
      "grammarTipsSection": "GRAMMAR TIPS",
      "soundMoreNativeSection": "SOUND MORE NATIVE",
      "studyThisSection": "STUDY THIS",
      "lessonLinkLabel": "Study: ",
      "reportButton": "Report",
      "reportAnalysisLabel": "Report analysis",
      "tip_one": "{{count}} tip",
      "tip_other": "{{count}} tips",
      "practiceThis": "Practice this"
    },
    "feedback": {
      "viewLabel": "View feedback",
      "view": "View",
      "expandLabel": "Expand feedback",
      "collapseLabel": "Collapse feedback",
      "collapseHint": "Tap to collapse ↑"
    },
    "quickPractice": {
      "title": "Quick Practice",
      "loading": "Generating practice...",
      "explanation": "Explanation",
      "examples": "Examples",
      "exercises": "Exercises"
    },
    "report": {
      "title": "Report AI Content",
      "question": "Report this AI-generated content as inappropriate or incorrect?",
      "duplicateMessage": "You have already reported this content. We will review it.",
      "successMessage": "Thank you for your feedback. We will review this AI response.",
      "cancelButton": "Cancel",
      "reportButton": "Report"
    },
    "connection": {
      "reconnecting": "Reconnecting...",
      "reconnectingSlow": "Taking longer than usual...",
      "failed": "Connection lost",
      "tapToReconnect": "Tap to reconnect",
      "sessionExpired": "Session expired",
      "signInAgain": "Sign in again",
      "queued": "Message queued — will send when connected"
    }
  },
  "conversations": {
    "title": "Conversations",
    "newConversation": "New conversation",
    "empty": "No conversations yet. Start a new one!",
    "untitled": "Untitled conversation",
    "messageCount": "{{count}} messages",
    "justNow": "just now",
    "minutesAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "daysAgo": "{{count}}d ago"
  },
  "hub": {
    "title": "Start Practicing",
    "subtitle": "Choose how you'd like to practice today",
    "historyButton": "Conversation history",
    "switchCourse": "Switch course",
    "pronunciation": {
      "title": "Pronunciation",
      "subtitle": "Practice speaking clearly"
    },
    "conversation": {
      "title": "Conversation",
      "subtitle": "Chat freely about anything"
    },
    "grammar": {
      "title": "Grammar",
      "subtitle": "Focus on grammar rules"
    },
    "roleplay": {
      "title": "Role Play",
      "subtitle": "Practice real-life scenarios"
    },
    "quickQuestion": {
      "title": "Quick Question",
      "subtitle": "Get a fast answer"
    }
  },
  "roleplay": {
    "list": {
      "title": "Role Play",
      "sectionYours": "Your Role Plays",
      "createCustom": "Create custom role play",
      "slotsFull": "{{cap}}/{{cap}} slots used",
      "slotLabel": "{{title}} — {{scenario}}",
      "templateLabel": "{{title}}",
      "loadErrorRetry": "Retry"
    },
    "templates": {
      "preview": {
        "title": "Role Play Preview",
        "sectionVocabulary": "Vocabulary",
        "sectionPhrases": "Key Phrases",
        "startButton": "Start this Role Play",
        "statusNew": "New",
        "statusLearning": "Learning",
        "statusMastered": "Mastered"
      }
    },
    "detail": {
      "title": "Role Play",
      "fieldScenario": "Scenario",
      "fieldDetails": "Details",
      "fieldUserRole": "You play",
      "fieldAiRole": "The AI plays",
      "fieldFirstSpeaker": "First to speak",
      "firstSpeakerUser": "You",
      "firstSpeakerAi": "The AI",
      "openButton": "Open conversation",
      "restartButton": "Restart",
      "removeButton": "Delete",
      "restartConfirmTitle": "Restart this role play?",
      "restartConfirmBody": "Your previous conversation for this scenario will be cleared and a new one will start with the same setup.",
      "restartConfirmButton": "Restart",
      "removeConfirmTitle": "Delete this role play?",
      "removeConfirmBody": "The scenario setup and its conversation will be deleted. This cannot be undone.",
      "removeConfirmButton": "Delete",
      "cancelButton": "Cancel"
    },
    "collections": {
      "sectionTitle": "Collections",
      "progress": "{{completed}}/{{total}} done",
      "cardLabel": "{{title}}, {{completed}} of {{total}} done",
      "searchPlaceholder": "Search role plays",
      "searchClear": "Clear search",
      "searchEmpty": "No matches. Try a different keyword.",
      "emptyHint": "No collections available yet.",
      "difficultyLabel": "Lvl {{level}}",
      "filterDifficultyLabel": "Filter by difficulty level {{level}}",
      "filterCompleted": "Completed",
      "filterUncompleted": "Not yet started"
    }
  },
  "practice": {
    "tip": "Tip: Practice 15 minutes daily for best results!",
    "continueLesson": "Continue",
    "resumeLesson": "Resume",
    "nextLesson": "Next",
    "loadingPath": "Loading lessons...",
    "pathError": "Unable to load lessons.",
    "noLessonsForLevel": "No lessons available for {{level}} yet",
    "updateLessons": "Update lessons",
    "selectLesson": "Select a lesson to get started",
    "recommended": {
      "title": "Recommended for you",
      "subtitle": "Based on the mistakes you make most often",
      "itemLabel": "Study: ",
      "focusLabel": "Practice in conversation: ",
      "mistakeCount_one": "{{count}} mistake",
      "mistakeCount_other": "{{count}} mistakes",
      "errorTypes": {
        "verb_tense": "Verb tenses",
        "past_tense": "Past tense",
        "present_simple": "Present simple",
        "present_continuous": "Present continuous",
        "present_perfect": "Present perfect",
        "future_forms": "Talking about the future",
        "passive_voice": "Passive voice",
        "conditionals": "Conditionals",
        "subjunctive": "Subjunctive",
        "modal_verbs": "Modal verbs",
        "auxiliary_verbs": "Auxiliary verbs",
        "gerund_vs_infinitive": "Gerund or infinitive",
        "reported_speech": "Reported speech",
        "verb_complementation": "Verb patterns",
        "question_tags": "Question tags",
        "phrasal_verbs": "Phrasal verbs",
        "question_formation": "Questions",
        "negation": "Negation",
        "there_is_are": "There is / there are",
        "subject_verb_agreement": "Subject-verb agreement",
        "modal_nuance": "Advanced modals",
        "articles": "Articles",
        "singular_plural": "Singular and plural",
        "countable_uncountable": "Countable and uncountable",
        "quantifiers": "Quantifiers",
        "possessives": "Possessives",
        "demonstratives": "Demonstratives",
        "pronouns": "Pronouns",
        "subject_pronoun_omission": "Subject pronouns",
        "reflexive_pronouns": "Reflexive pronouns",
        "gender_confusion": "He, she and it",
        "adjective_order": "Adjective order",
        "adjective_adverb": "Adjectives and adverbs",
        "adverb_position": "Adverb position",
        "comparatives": "Comparatives",
        "intensifiers": "Intensifiers",
        "degree_too_very_much": "Too, very and much",
        "word_order": "Word order",
        "sentence_structure": "Sentence structure",
        "relative_clauses": "Relative clauses",
        "conjunctions": "Conjunctions",
        "prepositions": "Prepositions",
        "duration_since_for": "Since and for",
        "ellipsis": "Ellipsis",
        "inversion": "Inversion",
        "cleft_sentences": "Cleft sentences",
        "fronting_emphasis": "Emphasis and fronting",
        "nominalization": "Nominalization",
        "vocabulary": "Vocabulary",
        "word_choice": "Word choice",
        "false_friends": "False friends",
        "collocations": "Word combinations",
        "spanish_transfer": "Direct translation",
        "ser_estar": "The verb \"be\"",
        "register": "Register",
        "pragmatics": "Politeness and tone",
        "discourse_markers": "Linking words",
        "coherence": "Coherence",
        "hedging_stance": "Hedging",
        "spelling": "Spelling",
        "punctuation": "Punctuation",
        "capitalization": "Capital letters",
        "pronunciation": "Pronunciation",
        "pronunciation_consonants": "Consonant sounds",
        "pronunciation_vowels": "Vowel sounds",
        "pronunciation_stress": "Word stress",
        "pronunciation_rhythm": "Rhythm",
        "pronunciation_prosody": "Intonation",
        "plural_pronunciation": "Plural endings",
        "word_stress": "Word stress",
        "connected_speech": "Connected speech",
        "reduced_forms": "Reduced forms",
        "accent_awareness": "Accents",
        "listening_comprehension": "Listening",
        "academic_listening": "Academic listening",
        "inference": "Inference",
        "main_idea": "Main idea",
        "critical_thinking": "Critical thinking",
        "media_literacy": "Media literacy",
        "note_taking": "Note-taking",
        "other": "Other"
      }
    },
    "categories": {
      "all": "All",
      "grammar": "Grammar",
      "vocabulary": "Vocabulary",
      "pronunciation": "Pronunciation",
      "communication": "Communication",
      "spanish-challenges": "Challenges",
      "listening": "Listening",
      "writing": "Writing",
      "culture": "Culture"
    },
    "cefrHints": {
      "a1": "Basic phrases and sentences",
      "a2": "Everyday expressions and routines",
      "b1": "Main points and personal experiences",
      "b2": "Complex texts and abstract topics",
      "c1": "Nuance, idiom, and fluency",
      "c2": "Near-native precision and range"
    }
  },
  "profile": {
    "header": {},
    "info": {
      "title": "Profile Information",
      "nameLabel": "Display name",
      "namePlaceholder": "How should we call you?",
      "nameHint": "This is how the AI will address you"
    },
    "appearance": {
      "title": "Appearance",
      "themeLabel": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    },
    "courses": {
      "title": "My Courses",
      "list": "Your courses",
      "activeCourse": "Active",
      "addCourse": "Add course",
      "removeCourseTitle": "Remove course",
      "removeCourseMessage": "Are you sure you want to remove this course? Your progress will be kept.",
      "courseLimitExceeded": "You can have up to {{max}} courses. Please remove one to add another.",
      "languageSettings": "Language settings"
    },
    "language": {
      "title": "Language",
      "appLanguage": "App language"
    },
    "audioSpeech": {
      "title": "Audio & Speech",
      "autoplayTitle": "Autoplay",
      "autoplayDescription": "Automatically read AI responses aloud",
      "micTest": "Microphone test",
      "micTestWebUnavailable": "Only available in the iOS and Android apps for now"
    },
    "learning": {
      "languageSettings": "Language settings",
      "autoplayTitle": "Autoplay",
      "ttsVoiceTitle": "Voice quality",
      "ttsVoiceDevice": "Device",
      "ttsVoiceAzure": "Neural",
      "ttsVoiceSelectLabel": "Voice",
      "debugContextSnapshotsTitle": "Context snapshots (debug)",
      "debugContextSnapshotsDescription": "Attach the exact AI prompt context to each reply's metadata, for debugging",
      "lessonFeedbackTitle": "Lesson feedback",
      "lessonFeedbackDescription": "Show feedback buttons in lesson content"
    },
    "subscription": {
      "title": "Subscription",
      "pro": "Fluencia Pro",
      "freeTrial": "Free Trial",
      "freePlan": "Free Plan",
      "daysRemaining_one": "{{count}} day remaining",
      "daysRemaining_other": "{{count}} days remaining",
      "upgradeMessage": "Upgrade for unlimited access",
      "manageAccessibility": "Manage subscription",
      "upgradeAccessibility": "Upgrade subscription"
    },
    "security": {
      "title": "Security",
      "changePassword": "Change Password",
      "changePasswordAccessibility": "Change password",
      "newPasswordLabel": "New Password",
      "newPasswordAccessibility": "New password",
      "newPasswordPlaceholder": "Enter new password",
      "confirmPasswordLabel": "Confirm Password",
      "confirmPasswordAccessibility": "Confirm new password",
      "confirmPasswordPlaceholder": "Confirm new password",
      "passwordMinLength": "Password must be at least 8 characters",
      "passwordsMismatch": "Passwords do not match",
      "passwordUpdated": "Password updated successfully"
    },
    "aiConsent": {
      "description": "Fluencia uses third-party AI services to provide pronunciation feedback and grammar analysis.",
      "granted": "Consent Granted",
      "notGranted": "Consent Not Granted",
      "dataSharedWith": "Your data may be shared with:",
      "notGrantedDescription": "AI-powered features are disabled. Grant consent when using the Chat feature to enable pronunciation and grammar feedback.",
      "withdrawButton": "Withdraw AI Consent",
      "withdrawTitle": "Withdraw AI Consent",
      "withdrawMessage": "Are you sure you want to withdraw AI consent?\n\nAI-powered features like pronunciation feedback and grammar analysis will be disabled."
    },
    "support": {
      "title": "Help & Support",
      "contactSupport": "Contact Support",
      "contactSupportAccessibility": "Contact support",
      "privacyPolicy": "Privacy Policy",
      "privacyPolicyAccessibility": "View privacy policy",
      "termsOfService": "Terms of Service",
      "termsOfServiceAccessibility": "View terms of service"
    },
    "devTools": {
      "title": "Developer Tools",
      "showAccessibility": "Show developer tools",
      "hideAccessibility": "Hide developer tools",
      "checkBackendHealth": "Check Backend Health",
      "environment": "Environment:",
      "commitBranch": "Commit / Branch:",
      "errorPrefix": "Error: {{message}}",
      "refreshAllData": "Refresh All Data",
      "refreshAllStarted": "Refreshing all data..."
    },
    "privacyLegal": {
      "title": "Privacy & Legal"
    },
    "account": {
      "sectionTitle": "Account",
      "title": "Account",
      "checkingStatus": "Checking account status...",
      "couldntLoadStatus": "Couldn't load account deletion status.",
      "deletionScheduled": "Account Deletion Scheduled",
      "deletionMessage": "Your account will be permanently deleted in",
      "day_one": "{{count}} day",
      "day_other": "{{count}} days",
      "scheduledFor": "Scheduled for: {{date}}",
      "cancelDeletion": "Cancel Deletion",
      "deleteDescription": "Permanently delete your account and all associated data. You will have 30 days to cancel before deletion is final.",
      "deleteButton": "Delete Account",
      "deleteConfirmTitle": "Delete Account",
      "deleteConfirmMessage": "Are you sure you want to delete your account?\n\nYour data will be permanently deleted in 30 days. You can cancel this request at any time during the grace period.",
      "deletionSuccess": "Account deletion scheduled. You have 30 days to cancel this request.",
      "cancellationSuccess": "Deletion request cancelled. Your account will not be deleted."
    },
    "logout": {
      "confirmTitle": "Logout",
      "confirmMessage": "Are you sure you want to logout?"
    }
  },
  "tabs": {
    "practice": "Practice"
  },
  "lessons": {
    "generatingExercises": "Generating personalized exercises...",
    "generatingExercisesSubtext": "This may take a few seconds",
    "exerciseGenerationError": "Unable to generate exercises. Please try again later.",
    "aiConsentRequired": "AI data sharing must be enabled to generate personalized exercises.",
    "enableAIExercises": "Enable AI Exercises",
    "generateExercisesPrompt": "Tap below to generate exercises tailored to your level.",
    "generateExercisesButton": "Generate Exercises",
    "generateNewExercises": "Generate New Exercises",
    "detail": {
      "exercises": "Exercises",
      "completeLesson": "Complete Lesson",
      "lessonUpdated": "This lesson has been updated. Tap to see the new version.",
      "exerciseNotSupported": "Exercise type \"{{type}}\" is not yet supported.",
      "exerciseSkipped": "This exercise couldn't be loaded. Try generating new ones.",
      "showAnswer": "Show Answer",
      "exercise": "Exercise",
      "noContent": "No content available",
      "unableToLoad": "Unable to load this lesson."
    },
    "scoreCard": {
      "excellent": "Excellent!",
      "great": "Great job!",
      "good": "Good effort!",
      "keepPracticing": "Keep practicing!",
      "newHighScore": "New high score!",
      "attempt": "Attempt #{{number}}",
      "best": "Best: {{score}}%",
      "nextReview_one": "Next review in {{count}} day",
      "nextReview_other": "Next review in {{count}} days",
      "continue": "Continue",
      "tryAgain": "Try Again"
    },
    "due": {
      "title": "Due for review",
      "sectionOverdue": "Overdue",
      "sectionReady": "Ready for review",
      "dueToday": "Due today",
      "overdueBy_one": "{{count}} day overdue",
      "overdueBy_other": "{{count}} days overdue",
      "lastScore": "Last score: {{score}}%",
      "empty": "All caught up! Nothing to review right now.",
      "browse": "Browse lessons",
      "card": {
        "title": "Due for review",
        "cta": "Revisit lessons you've completed",
        "caughtUp": "All caught up",
        "count_one": "{{count}} lesson due for review",
        "count_other": "{{count}} lessons due for review"
      }
    },
    "cefrLevels": {
      "a1": "Beginner",
      "a2": "Elementary",
      "b1": "Intermediate",
      "b2": "Upper Int.",
      "c1": "Advanced",
      "c2": "Mastery"
    },
    "feedback": {
      "button": "Give feedback",
      "sectionPlaceholder": "What did you think of this section?",
      "lessonPlaceholder": "What did you think of this lesson?",
      "submit": "Submit",
      "success": "Thanks for your feedback!",
      "error": "Could not submit feedback. Please try again."
    }
  },
  "paywall": {
    "successTitle": "Welcome to Fluencia Pro!",
    "successMessage": "Your subscription is now active. Enjoy unlimited access to all features!",
    "restoreSuccessTitle": "Purchases Restored",
    "restoreSuccessMessage": "Your subscription has been restored successfully!",
    "restoreNoMessage": "We could not find any previous purchases to restore.",
    "activeTitle": "You're a Pro!",
    "activeMessage": "You have full access to all Fluencia features.",
    "renews": "Renews:",
    "manageSubscription": "Manage Subscription",
    "unlockTitle": "Unlock Your Fluency",
    "upgradeToAccess": "Upgrade to access",
    "daysLeftInTrial": "{{count}} days left in trial",
    "proBenefitsTitle": "Pro Benefits",
    "unlimitedPronunciation": "Unlimited pronunciation assessments",
    "aiConversationPractice": "AI conversation practice",
    "accessAllLessons": "Access to all lessons",
    "detailedFeedback": "Detailed pronunciation feedback",
    "progressTracking": "Progress tracking & analytics",
    "prioritySupport": "Priority support",
    "viewSubscriptionOptions": "View Subscription Options",
    "restorePurchases": "Restore Purchases",
    "paymentCharged": "Payment will be charged to your",
    "appleId": "Apple ID",
    "googlePlay": "Google Play",
    "paymentMethod": "payment method",
    "autoRenewDisclaimer": "Subscription automatically renews unless canceled at least 24 hours before the end of the current period.",
    "termsOfService": "Terms of Service",
    "privacyPolicy": "Privacy Policy"
  },
  "exercises": {
    "hint": "Hint:",
    "errorCorrection": {
      "correctionFor": "Correction for \"{{word}}\":",
      "typeCorrection": "Type correction...",
      "apply": "Apply",
      "removeWord": "This word doesn't belong — remove it",
      "removeWordShort": "remove",
      "removeWordA11y": "Mark {{word}} as a word that should be removed",
      "wordA11y": "Word: {{word}}",
      "wordFlaggedA11y": "Word: {{word}}, flagged",
      "checkCorrections": "Check corrections",
      "allCorrect": "All corrections correct!",
      "score": "Score: {{score}}%"
    },
    "dialogueCompletion": {
      "selectAnswer": "Select an answer...",
      "typeAnswer": "Type your answer...",
      "answerForA11y": "Answer for {{speaker}}",
      "blankA11y": "Blank {{number}} in {{speaker}}'s line",
      "checkAnswer": "Check answer",
      "correct": "Correct!",
      "notQuite": "Not quite right",
      "expected": "Expected: \"{{answer}}\""
    }
  },
  "soundMap": {
    "title": "Sound Map",
    "loading": "Loading your sound map...",
    "loadError": "Unable to load your sound map.",
    "progressLabel": "{{mastered}} of {{total}} sounds mastered",
    "summary": {
      "mastered_one": "{{count}} mastered",
      "mastered_other": "{{count}} mastered",
      "learning_one": "{{count}} learning",
      "learning_other": "{{count}} learning",
      "weak_one": "{{count}} weak",
      "weak_other": "{{count}} weak",
      "untried_one": "{{count}} not tried",
      "untried_other": "{{count}} not tried"
    },
    "sections": {
      "consonants": "Consonants",
      "vowels": "Vowels",
      "diphthongs": "Diphthongs",
      "tones": "Tones"
    },
    "states": {
      "mastered": "Mastered",
      "learning": "Learning",
      "weak": "Weak",
      "untried": "Not tried yet"
    },
    "chip": {
      "scoreValue": "{{score}}%",
      "a11yMastered": "{{symbol}}, mastered, {{score}} percent",
      "a11yLearning": "{{symbol}}, learning, {{score}} percent",
      "a11yWeak": "{{symbol}}, weak, {{score}} percent",
      "a11yUntried": "{{symbol}}, not practiced yet",
      "a11yUntriedHard": "{{symbol}}, not practiced yet, expected to be hard"
    },
    "detail": {
      "exampleWordsTitle": "Example words",
      "statsAvgScore": "Average score",
      "statsAttempts": "Attempts",
      "statsLastPracticed": "Last practiced",
      "notPracticedYet": "You haven't practiced this sound yet.",
      "difficultyLabel": "Expected difficulty",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "This sound is usually hard for Spanish speakers.",
      "tipsTitle": "Tips",
      "practiceButton": "Practice this sound",
      "closeA11y": "Close sound details"
    },
    "practiceCard": {
      "title": "Sound Map",
      "subtitle": "Track your mastery of every sound",
      "cta": "Open the sound map"
    },
    "guidanceOnly": {
      "summary": "The English sounds that are hardest for Spanish speakers",
      "body": "These are the sounds of your English. The ones marked are the ones Spanish speakers usually find hardest — tap any of them for tips and to practise it with your tutor."
    }
  },
  "competenceMap": {
    "title": "Competence map",
    "loading": "Loading your competence map...",
    "loadError": "Could not load your competence map.",
    "progressLabel": "{{mastered}} of {{total}} competences mastered",
    "dueTitle": "Due for review",
    "bandEmpty": "There is no content at this level yet.",
    "bandCount_one": "{{count}} competence",
    "bandCount_other": "{{count}} competences",
    "bandLater_one": "{{count}} later on",
    "bandLater_other": "{{count}} later on",
    "summary": {
      "mastered_one": "{{count}} mastered",
      "mastered_other": "{{count}} mastered",
      "learning_one": "{{count}} in progress",
      "learning_other": "{{count}} in progress",
      "struggling_one": "{{count}} struggling",
      "struggling_other": "{{count}} struggling",
      "untried_one": "{{count}} not seen yet",
      "untried_other": "{{count}} not seen yet",
      "upcoming_one": "{{count}} later on",
      "upcoming_other": "{{count}} later on"
    },
    "bands": {
      "A1": "A1 · Beginner",
      "A2": "A2 · Elementary",
      "B1": "B1 · Intermediate",
      "B2": "B2 · Upper Int.",
      "C1": "C1 · Advanced",
      "C2": "C2 · Mastery",
      "any": "Any level"
    },
    "states": {
      "mastered": "Mastered",
      "learning": "In progress",
      "struggling": "Struggling",
      "untried": "Not seen yet",
      "upcoming": "Later on"
    },
    "chip": {
      "due": "Due",
      "a11y": "{{name}}, {{state}}",
      "a11yWithHard": "{{name}}, {{state}}, usually hard"
    },
    "detail": {
      "examplesTitle": "Examples",
      "exampleCorrect": "✓ {{text}}",
      "exampleIncorrect": "✗ {{text}}",
      "statsProductions": "Correct uses",
      "statsStruggles": "Mistakes",
      "statsSessions": "Sessions",
      "statsLastUsed": "Last used",
      "statsNextReview": "Next review",
      "notSeenYet": "We have not seen you use this yet.",
      "comesLater": "This comes later in your journey.",
      "difficultyLabel": "Expected difficulty",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "This is usually hard for Spanish speakers.",
      "tipsTitle": "Tips",
      "practiceButton": "Practise this",
      "closeA11y": "Close competence details"
    },
    "practiceCard": {
      "title": "Competence map",
      "subtitle": "Track your grammar mastery",
      "cta": "Open the competence map"
    }
  },
  "vocabulary": {
    "title": "Your vocabulary",
    "hubCard": {
      "title": "Your vocabulary",
      "subtitle": "Words and expressions you practice",
      "counts": "{{mastered}} mastered · {{due}} due for review"
    },
    "counts": {
      "new": "New",
      "learning": "Learning",
      "mastered": "Mastered"
    },
    "levels": {
      "title": "Your progress by level",
      "assessedTag": "your level",
      "progress": "{{mastered}} of {{total}} words",
      "breakdown": "{{mastered}} mastered · {{learning}} learning · {{fresh}} new",
      "due": "{{due}} due for review",
      "empty": "No {{level}} words in your progress yet. Try a role play to get started.",
      "note": "Levels are a rough guide to aim your practice, not an assessment of your level."
    },
    "due": {
      "title": "Due for review",
      "empty": "Nothing due right now. Keep it up!",
      "more": "and {{overflow}} more due for review"
    },
    "list": {
      "learning": "Learning",
      "mastered": "Mastered",
      "empty": "Nothing here yet. Try a role play to get started."
    },
    "error": {
      "retry": "Retry"
    }
  },
  "errorBoundary": {
    "title": "Something went wrong",
    "message": "We're sorry, but something unexpected happened. Our team has been notified and we're working to fix it.",
    "suggestion": "Please try again later.",
    "retryButton": "Try Again",
    "debugInfo": "Debug Info:"
  },
  "courseLoadError": {
    "title": "Couldn't load courses",
    "body": "Fluencia needs to download the course list before you can start. Check your connection and try again.",
    "errorPrefix": "Error",
    "retry": "Try again",
    "retrying": "Trying again…"
  },
  "featureGate": {
    "features": {
      "pronunciationAssessments": "Pronunciation Assessments",
      "aiConversations": "AI Conversations",
      "lessons": "Lessons",
      "detailedFeedback": "Detailed Feedback",
      "audioLessons": "Audio Lessons"
    },
    "upgradeToUnlock": "Upgrade to Pro to unlock this feature",
    "unlockMoreFeatures": "Unlock More Features",
    "unlockDescription": "Upgrade to Fluencia Pro for unlimited access to all features.",
    "trialActive": "Trial Active",
    "upgradeToPro": "Upgrade to Pro",
    "viewSubscription": "View Subscription",
    "upgradeNow": "Upgrade Now",
    "trialExpiresToday": "Trial expires today!",
    "trialDaysLeft_one": "{{count}} day left in your trial",
    "trialDaysLeft_other": "{{count}} days left in your trial",
    "featureRequiresPro": "This feature requires Fluencia Pro. Upgrade to unlock unlimited access."
  },
  "audioLessons": {
    "title": "Listen",
    "grammarGroupTitle": "Grammar on the go",
    "emptyHint": "No audio lessons yet",
    "loadErrorRetry": "Retry",
    "episodeCount_one": "{{count}} episode",
    "episodeCount_other": "{{count}} episodes",
    "seriesProgress": "{{completed}} of {{total}} completed",
    "seriesCardLabel": "{{title}}, {{count}} episodes",
    "listenOnTheGo": "Listen on the go",
    "series": {
      "emptyHint": "No episodes yet",
      "episodeLabel": "{{title}}",
      "resume": "Resume",
      "completed": "Completed",
      "premium": "Pro"
    },
    "player": {
      "play": "Play",
      "pause": "Pause",
      "skipBack": "Skip back {{seconds}} seconds",
      "skipForward": "Skip forward {{seconds}} seconds",
      "seek": "Seek",
      "loadError": "We couldn't load this episode.",
      "retry": "Retry",
      "taughtIn": "Taught in",
      "transcript": "Transcript",
      "renditionUnavailable": "That language isn't available for this episode."
    }
  },
  "native": {
    "language": "English",
    "variant": "United States",
    "variantHint": "color, organize",
    "testPhrase": "The weather is beautiful today"
  },
  "countryPicker": {
    "title": "Select your country",
    "suggested": "Suggested"
  },
  "languageSettings": {
    "country": "Country",
    "variant": "Language Variant",
    "variantHint": "Your country has multiple language communities. Choose the variant closest to you.",
    "lessonLanguage": "Lesson Language",
    "targetLocale": "Learning Variant",
    "targetLocaleHint": "Choose which accent and vocabulary you want to learn."
  },
  "onboarding": {
    "title": "Set up your experience",
    "subtitle": "We'll personalize your lessons based on your region.",
    "confirm": "Continue"
  },
  "updates": {
    "availableTitle": "Update Available",
    "availableMessage": "A new version has been downloaded. Restart to apply the update?",
    "later": "Later",
    "restart": "Restart"
  },
  "messages": {
    "forceUpdate": {
      "title": "Update Required",
      "body": "This version of Fluencia is no longer supported. Please update to continue.",
      "action": "Update Now"
    },
    "softUpdate": {
      "title": "Update Available",
      "body": "A new version of Fluencia is available with improvements and bug fixes.",
      "action": "Update",
      "dismiss": "Later"
    },
    "announcement": {
      "title": "What's New",
      "body": "Check out the latest features and improvements.",
      "action": "Learn More"
    }
  },
  "errors": {
    "api": {
      "OFFLINE": "You're offline. Check your internet connection.",
      "SERVER_UNREACHABLE": "Can't reach the server. Please try later.",
      "TIMEOUT": "Request timed out. Please try again.",
      "VALIDATION_FAILED": "Please check your input and try again.",
      "NOT_FOUND": "The requested resource was not found.",
      "USER_NOT_FOUND": "User not found.",
      "RATE_LIMITED": "Too many requests. Please wait a moment.",
      "QUOTA_EXCEEDED": "Usage limit reached.",
      "UNAUTHORIZED": "Authentication required. Please sign in.",
      "TOKEN_EXPIRED": "Your session has expired. Please sign in again.",
      "FORBIDDEN": "Access denied.",
      "AI_CONSENT_REQUIRED": "Please accept AI data sharing to use this feature.",
      "ACCOUNT_DELETED": "This account has been deleted.",
      "INTERNAL_ERROR": "Something went wrong.",
      "SERVICE_UNAVAILABLE": "Service temporarily unavailable. Please try later.",
      "AI_SERVICE_ERROR": "AI service error. Please try again.",
      "AI_PROVIDER_ERROR": "AI service error. Please try again.",
      "AI_EMPTY_RESPONSE": "No response received. Please try again.",
      "AI_STREAM_ERROR": "Response interrupted. Please try again.",
      "DATABASE_ERROR": "Something went wrong.",
      "UNKNOWN": "Something went wrong.",
      "SESSION_BUSY": "This conversation is being used on another device. Please wait.",
      "ROLEPLAY_SLOTS_FULL": "You already have {{cap}} role plays. Delete one to create a new scenario.",
      "ROLEPLAY_SLOT_NOT_FOUND": "This role play no longer exists.",
      "ROLEPLAY_SETUP_INVALID": "Something went wrong with the setup. Try again.",
      "ROLEPLAY_TEMPLATE_NOT_FOUND": "This template is no longer available."
    },
    "auth": {
      "INVALID_CREDENTIALS": "Invalid email or password. Please try again.",
      "USER_NOT_FOUND": "No account found with this email address.",
      "EMAIL_NOT_CONFIRMED": "Please verify your email before logging in. Check your inbox for the confirmation link.",
      "USER_ALREADY_EXISTS": "An account with this email already exists. Try logging in instead.",
      "WEAK_PASSWORD": "Password is too weak. Please use at least 8 characters with a mix of letters and numbers.",
      "RATE_LIMITED": "Too many attempts. Please wait a moment and try again.",
      "SAME_PASSWORD": "New password must be different from your current password.",
      "RESET_LINK_EXPIRED": "Reset link has expired. Please request a new one.",
      "RECOVERY_CODE_INVALID": "That code is invalid or has expired. Request a new one.",
      "SIGNUP_CODE_INVALID": "That code is invalid or has expired. Request a new one.",
      "SESSION_EXPIRED": "Your session has expired. Please log in again.",
      "UNKNOWN": "An authentication error occurred. Please try again."
    },
    "generic": {}
  },
  "micTest": {
    "title": "Microphone Test",
    "instructions": "Read the phrase below aloud to verify your microphone is working correctly.",
    "sayThisPhrase": "Say this phrase:",
    "startTest": "Start Test",
    "recording": "Recording...",
    "testAgain": "Test Again",
    "youSaid": "We heard:",
    "resultWorking": "Your microphone is working well",
    "resultWorkingDetail": "Audio is clear and speech was recognized successfully.",
    "resultQuality": "We can hear you, but audio quality could be better",
    "resultQualityTip1": "Move to a quieter environment",
    "resultQualityTip2": "Hold your phone closer to your mouth",
    "resultQualityTip3": "Check if your phone case is covering the microphone",
    "resultNotDetected": "We could not detect your voice",
    "resultNotDetectedTip1": "Make sure your microphone is not blocked",
    "resultNotDetectedTip2": "Try removing your phone case",
    "resultNotDetectedTip3": "Close other apps that may be using the microphone",
    "resultNotDetectedTip4": "Restart the app and try again",
    "tipsTitle": "Tips",
    "errorConnection": "Could not connect to speech service. Check your internet connection."
  },
  "vocabSets": {
    "title": "Word sets",
    "drillTitle": "Practice",
    "loading": "Loading…",
    "loadError": "We couldn't load the word sets.",
    "intro": "Groups of words to practise directly. Type the English word — it only counts if you produce it yourself.",
    "countLabel": "{{done}} of {{total}} mastered",
    "inputPlaceholder": "Type the English word",
    "check": "Check",
    "reveal": "Show the answer",
    "next": "Next",
    "empty": "This set has no words yet.",
    "markError": "We couldn't save your answer. Please try again.",
    "speak": "Say it out loud",
    "pronunciationScore": "Pronunciation: {{score}}/100",
    "notHeard": "We couldn't hear you clearly. Try again."
  }
}
